/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
import { h600 } from '@atlaskit/theme/typography';

// eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
var headerStyles = css([h600(), {
  marginTop: 0,
  marginBottom: "".concat(getGridSize() * 2, "px")
}]);

/**
 * __Header__
 *
 * Header of Empty State.
 *
 * @internal
 */
var EmptyStateHeader = function EmptyStateHeader(_ref) {
  var children = _ref.children;
  return jsx("h4", {
    css: headerStyles
  }, children);
};
export default EmptyStateHeader;